<div class="events-container page-container">
  <div class="events">
    <app-events-slider (selectedNewEvent)="selectedEvent($event)"></app-events-slider>
  </div>
  <div class="events-description" *ngIf="activeEvent" @fadeInOut>
    <h1>{{ activeEvent.title | translate }}</h1>
    <p>{{ activeEvent.description | translate }}</p>
    <button mat-raised-button class="contrast-button" *ngIf="!isEventDetailsVisible" (click)="seeEventDetails()">
      {{ 'seeImages' | translate }}
    </button>
    <button mat-raised-button class="contrast-button" *ngIf="isEventDetailsVisible" (click)="hideEventDetails()">
      {{ 'hideImages' | translate }}
    </button>
  </div>

  <div class="event-details" *ngIf="isEventDetailsVisible" @fadeInOut>
    <div *ngFor="let url of eventUrls" class="event-img">
      <img [src]="url">
    </div>
  </div>

</div>

